/* eslint-disable */
export default {
  cancel: 'Annulla',
  pmiChangeConfirmed: 'Modifica',
  pmiChangeConfirmTitle: 'Modificare impostazioni riunione personale?',
  pmiChangeConfirmContext:
    'La modifica di queste impostazioni avrà effetto su tutte le riunioni che utilizzano il tuo ID o nome riunione personale, comprese quelle che hai già programmato',
  updatePassword: 'Aggiorna password',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"pmiChangeConfirmed"@#@ @source: @#@"Change"@#@
// @key: @#@"pmiChangeConfirmTitle"@#@ @source: @#@"Change Personal Meeting settings?"@#@
// @key: @#@"pmiChangeConfirmContext"@#@ @source: @#@"Changing these settings will affect all meetings that use your personal meeting ID or name, including those you've already scheduled"@#@
// @key: @#@"updatePassword"@#@ @source: @#@"Update password"@#@
